import { render, staticRenderFns } from "./UnClipper.vue?vue&type=template&id=58a3d210&lang=pug&"
import script from "./UnClipper.vue?vue&type=script&lang=js&"
export * from "./UnClipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports